import { useCreateDocumentBatchMutation } from '~main/actions/documentBatches';

export const useDocumentBatchGeneration = () => {
  const [createDocumentBatch, { isLoading }] = useCreateDocumentBatchMutation();

  const createSeparateJobs = (documentType: string, documentIds: string[], onCompleteAction?: string) => {
    return documentIds.map((id) => ({
      document_type: documentType,
      document_id: id,
      ...(onCompleteAction && { on_complete_action: onCompleteAction }),
    }));
  };

  const emailSeparate = (documentType: string, documentIds: string[]) => {
    const jobs = createSeparateJobs(documentType, documentIds, 'email');
    return createDocumentBatch(jobs);
  };

  const generateSeparate = (documentType: string, documentIds: string[]) => {
    const jobs = createSeparateJobs(documentType, documentIds);
    return createDocumentBatch(jobs);
  };

  const generateCombined = (documentType: string, documentIds: string[]) => {
    const job = {
      document_type: documentType,
      document_ids: documentIds,
    };

    return createDocumentBatch([job]);
  };

  return {
    generateSeparate,
    generateCombined,
    emailSeparate,
    isGenerating: isLoading,
  };
};
